import { createContext } from 'react';
import { type AppState } from '../types/AppState';

export const AppStateContext = createContext<AppState>({
  isHidden: false,
  isSavedCard: false,
  appId: null,
  labelsStyle: 'regular',
  omitOffset: false,
  isFullWidth: false,
});
